import { render, staticRenderFns } from "./SurchargesTable.vue?vue&type=template&id=d19ed63a&"
import script from "./SurchargesTable.vue?vue&type=script&lang=js&"
export * from "./SurchargesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports